// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3lrU4","actionsCol":"EnrolledClinics_actionsCol__Wesvf"};